import { useEffect, useState } from "react";
import {
  fetchNewsFeed,
  NewsFeedMessage,
  NEWS_POLL_INTERVAL,
} from "modules/newsFeedService";

// News feed for display. Azure blob storage is the source of truth; it is
// published through the Admin form or static/news-admin.html - see the
// News Feed section of the README. Nothing in this app writes to it.
// Polls so a message published while the tab is open appears without a
// reload (NewsFeedBanner does the same for signed-out visitors).
export function useNewsFeed() {
  const [newsFeed, setNewsFeed] = useState<NewsFeedMessage | undefined>();

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      fetchNewsFeed().then((data) => {
        if (!cancelled) {
          setNewsFeed(data ?? undefined);
        }
      });
    };
    load();
    const interval = setInterval(load, NEWS_POLL_INTERVAL);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return { newsFeed };
}

export default useNewsFeed;
